<div fxFlex fxLayout="column" class="content-wrap">
  <!-- Toolbar -->
  <mat-toolbar>
    <app-menu-button fxLayout="column" class="menu-button"></app-menu-button>

    <div fxFlex.gt-sm fxLayout="row">
      <h2 fxFlex.gt-sm class="title">Time Allocation</h2>

      <button mat-button class="primary-color history-button toolbar-action-button" routerLink="./../time-allocation-history">
        <mat-icon class="icon-history"></mat-icon>
        <span fxHide fxShow.gt-sm>Allocation History</span>
      </button>
    </div>
  </mat-toolbar>

  <!-- Content -->
  <div fxFlex class="allocation-content">
    <div class="progress" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>

    <form *ngIf="!loading" [formGroup]="allocationForm" (ngSubmit)="onSubmit(allocationForm)">
      <div fxLayout="column" class="inner-container allocation-form">

        <div fxLayout="row">
          <mat-form-field fxFlex="47.5">
            <mat-label>Date of Service</mat-label>
            <label>
              <input matInput readonly formControlName="serviceDate" [matDatepicker]="picker">
            </label>
            <mat-datepicker-toggle matSuffix [for]="picker">
              <mat-icon matDatepickerToggleIcon class="icon-calendar"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker color="accent"></mat-datepicker>
          </mat-form-field>

          <mat-form-field fxFlex="47.5" fxFlexOffset="5">
            <mat-label>Facility Worked</mat-label>
              <mat-select formControlName="location" (selectionChange)="locationChanged($event)" hideSingleSelectionIndicator>
                <mat-option *ngFor="let location of allocationLocations" [value]="location.locationID">
                  {{location.locationShortName}}
                </mat-option>
              </mat-select>
          </mat-form-field>
        </div>

        <div fxLayout="row">
          <mat-form-field fxFlex="100">
            <mat-label>Type of Service</mat-label>
              <mat-select formControlName="service" (selectionChange)="serviceChanged($event)" hideSingleSelectionIndicator>
                <mat-option *ngFor="let service of allocationServices" [value]="service">
                  {{service.serviceDescription}}
                </mat-option>
              </mat-select>
          </mat-form-field>
        </div>

        <div *ngIf="showRoles" fxLayout="row">
          <mat-form-field fxFlex="100">
            <mat-label>Facility Role</mat-label>
              <mat-select formControlName="role" hideSingleSelectionIndicator>
                <mat-option *ngFor="let role of allocationRoles" [value]="role.allocationRoleID">
                  {{role.roleDescription}}
                </mat-option>
              </mat-select>
          </mat-form-field>
        </div>
          
        <div fxLayout="row">
          <mat-form-field fxFlex="47.5">
            <mat-label>Hours Worked</mat-label>
            <label>
              <input formControlName="hoursWorked" matInput type="number" inputmode="decimal">
            </label>
          </mat-form-field>

          <mat-form-field fxFlex="47.5" fxFlexOffset="5">
            <mat-label>Hours Traveled</mat-label>
            <label>
              <input formControlName="hoursTraveled" matInput type="number" inputmode="decimal">
            </label>
          </mat-form-field>
        </div>

        <div fxLayout="row">
          <mat-error *ngIf="allocationForm.get('hoursWorked')?.errors?.['allocatedHours']">
            Only enter 0.5-24 'Hours Worked' with up to two decimal places (ex. 10.75).
          </mat-error>
        </div>

        <div fxLayout="row">
          <mat-error *ngIf="allocationForm.get('hoursTraveled')?.errors?.['allocatedHours']">
            Only enter 0.5-24 'Hours Traveled' with up to two decimal places (ex. 10.75). If you do not need to allocate 'Hours Traveled', then leave this field blank.
          </mat-error>
        </div>

        <div fxLayout="row">
          <mat-form-field fxFlex="100">
            <mat-label>Note</mat-label>
            <label>
              <textarea formControlName="note" matInput></textarea>
            </label>
          </mat-form-field>
        </div>

        <div fxLayout="row">
          <button [disabled]="!allocationForm.valid" fxFlex mat-flat-button color="primary">SUBMIT</button>
        </div>
      </div>
    </form>
  </div>
</div>